// avatar default picture
export const defaultAvatarUrl = 'https://firebasestorage.googleapis.com/v0/b/vue-login-925c7.appspot.com/o/images%2Favatar_empty1.png?alt=media&token=2460684d-10d4-4c6e-8cdf-e3ac212763dd'
